export default {"src":"/_next/static/media/check-dark-green-rounded.3cf678f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};